import { VersionedTransaction } from '@exodus/solana-web3.js';
import api from '@exodus/solana-api';
import { NEW_TOKEN_ACCOUNT_FEE } from './constants';
export const updateBlockhash = async (base64Transaction) => {
    try {
        const transaction = VersionedTransaction.deserialize(Buffer.from(base64Transaction, 'base64'));
        const recentBlockhash = await api.getRecentBlockHash();
        transaction.message.recentBlockhash = recentBlockhash;
        return Buffer.from(transaction.serialize()).toString('base64');
    }
    catch (err) {
        console.warn(`Failed to update blockhash: ${err}`);
        return null;
    }
};
export const calculateTokenAccountsFee = (fromAssetId, toAssetId) => {
    if (fromAssetId === 'SOL') {
        return NEW_TOKEN_ACCOUNT_FEE * 2;
    }
    if (toAssetId === 'SOL') {
        return NEW_TOKEN_ACCOUNT_FEE;
    }
    return NEW_TOKEN_ACCOUNT_FEE;
};
export const promiseWithTimeout = async (params) => {
    const { promise, delayMs } = params;
    const delayPromise = new Promise((resolve) => setTimeout(() => resolve('timeout'), delayMs));
    const result = await Promise.race([delayPromise, promise]);
    if (result === 'timeout') {
        throw new Error('Timeout');
    }
    return result;
};
